import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-WorkPlacements-StudentDrawer', [
  'closeButton',
  'requiredChecksSection',
  'checklistItem',
  'nominationsSection',
  'nominationItem',
  'awaitingNominationItem',
  'nominationAcceptButton',
  'nominationRejectButton',
  'nominationReviewStatus',
  'trackedEmployerMenuButton',
  'saveToDirectoryMenuItem',
  'logContactMenuItem',
  'changeContactStatusMenuItem',
  'changeContactStatusModal',
  'contactStatusBadge',
  'requestAnotherNominationButton',
  'cancelNominationRequestButton',
  'acceptButton',
  'rejectButton',
  'addPlacementModal',
  'addRequirementButton',
  'removeRequirementButton',
  'documentTypeSelect',
  'addPlacementMenuItem',
  'changeStageMenuItem',
  'changeStageConfirm',
  'stepperStageButton',
  'placeStudentButton',
  'placementActionsMenu',
  'requestEvidenceButton',
  'markCompleteButton',
  'markFailedButton',
  'cancelPlacementButton',
  'placementActionConfirm',
  'placementStepper',
  'onHoldMenuItem',
  'onHoldBadge',
  'placementDetailsSection',
  'agreementDownloadButton',
  'agreementContractLink',
  'reviewAlert',
  'placementHistorySection',
  'historyItem',
  'uploadDocumentButton',
  'uploadDocumentModal',
  'uploadDocumentTypeSelect',
  'uploadDocumentHeaderButton',
  'manageUnitsButton',
  'manageUnitsCloseButton',
  'unitCheckbox',
  'saveUnitsButton',
  'contractSection',
  'setUpContractButton',
  'contractStatusBadge',
  'contractLockedReason',
  'contractEmployerField',
  'contractContactField',
  'contractDocumentLink',
  'contractSignatureRow',
  'markSignatureButton',
  'undoSignatureButton',
  'removeContractButton',
  'contractDocumentUrlInput',
  'createContractButton',
]);
